import { makeStyles } from "@mui/styles";

export const useStyles = makeStyles({
	content: {
    textAlign: "center",
  },
  table: {
    width: "100%",
    height: "100%",
  },
});
